<template>
	<db-col class="checkbox-normal-wrapper" :class="disabled ? 'checkbox-disabled' : ''" :width="width" :height="height" valign="middle" v-if="type == 'normal'" @click="clickHandler">
		<db-icon width="32" height="32" icon="check" size="24" :class="checkboxClass" />
		{{label}}
	</db-col>
	<db-col class="checkbox-card-wrapper" width="auto" :class="checkboxClass" :disabled="disabled" :height="height" v-else @click="clickHandler" valign="middle">
		{{label}}
	</db-col>
</template>

<script>
	export default {
		name: 'checkbox_',
		
		props: {
			height: {
				type: [String, Number],
				default: 'auto'
			},
			
			width: {
				type: [String, Number],
				default: 'auto'
			},
			
			type: {
				type: String,
				default: 'normal'
			},
			
			label: {
				type: [String, Number],
				default: ''
			},
			
			value: {
				type: [Boolean, String, Number],
				default: false
			},
			
			disabled: {
				type: Boolean,
				default: false
			},
			
			group: {
				type: Array,
				default(){
					return []
				}
			}
		},
		
		computed: {
			checkboxClass(){
				return ['check-boxer', 'check-chose-' + this.value, this.type == 'card' ? (this.disabled ? 'checkbox-disabled' : '') : '']
			}
		},
		
		methods: {
			clickHandler(){
				event.stopPropagation()
				if(!this.disabled){
					const val = !this.value
					this.$emit('input', val)
					this.$emit('click', val)
				}
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	@import '../../../../assets/styles/vars.scss';
	
	.checkbox-normal-wrapper{
		font-size: 28px;
		line-height: 28px;
		color: #666666;
		
		.check-boxer{
			font-weight: bold;
			border-radius: 80px;
			margin-right: 18px;
			transition: all .3s;
			//padding-top: 4px;
			
			&.check-chose-true{
				border: solid 2px $btn_primary_color;
				background: $btn_primary_color;
				color: #fff;
			}
			&.check-chose-false{
				border: solid 2px $btn_info_color;
				background: transparent;
				color: transparent;
			}
		}
		
		&.checkbox-disabled{
			color: #ccc;
			
			.check-chose-true{
				border: solid 2px $btn_info_color;
				background: $btn_info_color;
				color: #fff;
			}
			.check-chose-false{
				border: solid 2px $btn_info_color;
				background: rgba($btn_info_color, .4);
				color: transparent;
			}
		}
	}
	
	.checkbox-card-wrapper{
		padding: 4px 16px;
		font-size: 28px;
		border-radius: 88px;
		transition: all .3s;
		
		&.check-chose-true{
			border: solid 2px $btn_primary_color;
			background: $btn_primary_color;
			color: #fff;
		}
		&.check-chose-false{
			border: solid 2px #ccc;
			background: transparent;
			color: #666;
		}
		
		&.checkbox-disabled{
			font-style: italic;
			
			&.check-chose-true{
				border: solid 0 transparent;
				background: rgba($btn_primary_color, .4);
				color: #fff;
			}
			&.check-chose-false{
				border: solid 2px #ccc;
				background: rgba(#ccc, .3);
				color: #ccc;
			}
		}
	}
</style>
